import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    component: () => import("../views/Login.vue"),
    alias: "/login"
  },
  {
    path: "/power",
    name: "Power",
    component: () => import("../views/power/index.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/tv",
    name: "TV Subscription",
    component: () => import("../views/tv/index.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/data",
    name: "Data",
    component: () => import("../views/data/index.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "*",
    name: "404",
    component: () => import("../views/404.vue")
  }
];

const router = new VueRouter({
  routes
});

router.beforeEach((to, from, next) => {
  const loggedIn = sessionStorage.getItem("setResponse");
  if (to.matched.some(record => record.meta.requiresAuth) && loggedIn == null) {
    next("/");
  } else {
    next();
  }
});

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
    // Start the route progress bar.
    NProgress.start();
  }
  next();
});

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  NProgress.done();
});

export default router;
